import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import { getMultipleHourDataApi, getMultipleDayDataApi, getMultipleMonthDataApi, getMultipleYearDataApi } from '@/api';
import { dbDataHandle } from '@/store/function/common/index';
import { isDateAfterToday } from '@/utils/datetime';

import { mapState, mapActions } from 'vuex';
import { DateTime } from 'luxon';
import downloadCsv from 'download-csv';
export default {
  name: 'MultipleFactoryAnalysis',
  computed: _objectSpread({}, mapState(['factoryInfo'])),
  data: function data() {
    return {
      beginDate: DateTime.local().toFormat('yyyy-MM-dd'),
      endDate: DateTime.local().toFormat('yyyy-MM-dd'),
      dateType: 'date',
      dateTypeActive: 'hour',
      contextDataClass: ['PR值-pr', '環境溫度-ENVTemp', '等效日照時數(h)-IRR', '峰瓩值(kWh/kWp)-acp'],
      dataClass: ['發電量', '日照量', '實際累積發電量'],
      countyArr: [],
      factoryArr: [],
      multipleChartDataArr: [],
      contextArr: [{
        value: 'PR值-pr',
        text: 'PR值'
      }, {
        value: '環境溫度-ENVTemp',
        text: '環境溫度'
      }, {
        value: '等效日照時數(h)-IRR',
        text: '等效日照時數(h)'
      }, {
        value: '峰瓩值(kWh/kWp)-acp',
        text: '峰瓩值(kWh/kWp)'
      }],
      multipleDataArr: [{
        county: '高雄市',
        factory: '鳳山圳滯洪池',
        color: '#f6b73c'
      }, {
        county: 'null',
        factory: '',
        color: '#000000'
      }],
      multipleChart: {
        chart: {
          height: 350,
          backgroundColor: null,
          events: {
            load: function load() {
              this.showLoading('尚未有資料，請選擇案場');
            }
          }
        },
        credits: {
          enabled: false
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: []
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true
            }
          }
        },
        legend: {
          layout: 'horizontal',
          align: 'center',
          verticalAlign: 'bottom',
          floating: false
        },
        yAxis: [],
        tooltip: {
          shared: true
        },
        series: [],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 500
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                align: 'center',
                verticalAlign: 'bottom',
                y: 0
              }
            }
          }]
        }
      },
      downloadArrayForExcel: [] // 另存 excel 用 (copy multipleChart.series)
    };
  },
  methods: _objectSpread(_objectSpread({}, mapActions(['asyncInfo'])), {}, {
    isDateAfterToday: isDateAfterToday,
    multipleDataPush: function multipleDataPush() {
      this.multipleDataArr.push({
        county: 'null',
        factory: '',
        context: {
          values: 'pr',
          text: 'PR值'
        },
        color: '#000000'
      });
    },
    multipleDataSplice: function multipleDataSplice(idx) {
      this.multipleDataArr.splice(idx, 1);
    },
    changeDateType: function changeDateType(type, format, active) {
      this.dateTypeActive = active;
      this.dateType = type;
      this.beginDate = DateTime.local().toFormat("".concat(format));
      this.endDate = DateTime.local().toFormat("".concat(format));
    },
    buildOptionArr: function buildOptionArr() {
      var _this = this;
      this.countyArr = [];
      this.factoryArr = this.factoryInfo.filter(function (item) {
        return !item.isDemoSite;
      }).map(function (x) {
        if (!_this.countyArr.includes(x.informations.county)) {
          _this.countyArr.push(x.informations.county);
        }
        return {
          county: x.informations.county,
          factory: x.factory,
          factoryId: x.factoryId
        };
      });
    },
    filterFactoryArr: function filterFactoryArr(county) {
      if (county === 'null') return this.factoryArr;
      return this.factoryArr.filter(function (x) {
        return x.county === county;
      });
    },
    confirmData: function confirmData() {
      if (this.multipleDataArr.every(function (x) {
        return Object.values(x).every(function (y) {
          return y !== '';
        });
      })) {
        if (this.dateTypeActive === 'hour') this.getMultipleHourData();
        if (this.dateTypeActive === 'date') this.getMultipleDayData();
        if (this.dateTypeActive === 'month') this.getMultipleMonthData();
        if (this.dateTypeActive === 'year') this.getMultipleYearData();
      } else {
        this.$swal('請正確選擇');
      }
    },
    buildChart: function buildChart() {
      var _this2 = this;
      this.multipleChart.yAxis = [];
      this.multipleChart.series = [];
      this.downloadArrayForExcel = [];
      this.buildYaxis();
      this.defaultXaxis();
      this.multipleChartDataArr.forEach(function (x) {
        x.forEach(function (y) {
          _this2.contextDataClass.forEach(function (s) {
            var index = _this2.multipleChart.xAxis.categories.findIndex(function (q) {
              return q === y.time;
            });
            if (index >= 0) {
              // chart 顯示調整過數值
              _this2.multipleChart.series.find(function (z) {
                return z.context === s.split('-')[1] && z.name.split('_')[0] === y.siteName;
              }).data[index] = dbDataHandle(y[s.split('-')[1]]);

              // excel 存 rawdata
              _this2.downloadArrayForExcel.find(function (z) {
                return z.context === s.split('-')[1] && z.name.split('_')[0] === y.siteName;
              }).data[index] = y[s.split('-')[1]];
            }
          });
        });
      });
      this.hideHighChartLoading();
    },
    hideHighChartLoading: function hideHighChartLoading() {
      this.$nextTick(function () {
        if (this.$refs && this.$refs.chart) {
          this.$refs.chart.chart.hideLoading();
          this.multipleChart.chart.events = {};
        }
      });
    },
    buildYaxis: function buildYaxis() {
      var _this3 = this;
      for (var i = 0; i < this.multipleDataArr.length; i++) {
        var _loop = function _loop(j) {
          if (i === 0) {
            _this3.multipleChart.yAxis.push({
              title: {
                text: "".concat(_this3.contextDataClass[j].split('-')[0])
              },
              opposite: j % 2 === 0
            });
          }
          var obj = {
            type: 'line',
            color: _this3.multipleDataArr[i].color === '' ? '#000000' : _this3.multipleDataArr[i].color,
            name: "".concat(_this3.multipleDataArr[i].factory, "_").concat(_this3.contextDataClass[j].split('-')[0]),
            context: _this3.contextDataClass[j].split('-')[1],
            data: [],
            yAxis: _this3.multipleChart.yAxis.findIndex(function (z) {
              return z.title.text === _this3.contextDataClass[j].split('-')[0];
            })
          };
          _this3.multipleChart.series.push(obj);

          // 下載 excel 用，不 refer 同個 obj
          var objForExcel = {
            name: "".concat(_this3.multipleDataArr[i].factory, "_").concat(_this3.contextDataClass[j].split('-')[0]),
            context: _this3.contextDataClass[j].split('-')[1],
            data: []
          };
          _this3.downloadArrayForExcel.push(objForExcel);
        };
        for (var j = 0; j < this.contextDataClass.length; j++) {
          _loop(j);
        }
      }
    },
    defaultXaxis: function defaultXaxis() {
      this.multipleChart.xAxis.categories = [];
      if (this.dateTypeActive === 'hour') {
        for (var i = 0; i <= 24; i++) {
          this.multipleChart.xAxis.categories.push("0".concat(i).slice(-2) + ':00');
        }
        this.multipleChart.series.forEach(function (x) {
          for (var _i = 0; _i < 24; _i++) {
            x.data.push(null);
          }
        });

        // 下載 excel 用
        this.downloadArrayForExcel.forEach(function (x) {
          for (var _i2 = 0; _i2 < 24; _i2++) {
            x.data.push(null);
          }
        });
      } else {
        var beginDate = this.beginDate;
        var endDate = this.endDate;
        var diff;
        if (this.dateTypeActive === 'date') {
          diff = DateTime.fromISO(endDate).diff(DateTime.fromISO(beginDate), 'days').days;
        }
        if (this.dateTypeActive === 'month') {
          diff = DateTime.fromISO(endDate).diff(DateTime.fromISO(beginDate), 'months').months;
        }
        if (this.dateTypeActive === 'year') {
          diff = DateTime.fromISO(endDate).diff(DateTime.fromISO(beginDate), 'years').years;
        }
        for (var _i3 = 0; _i3 <= diff; _i3++) {
          if (this.dateTypeActive === 'date') {
            this.multipleChart.xAxis.categories.push(DateTime.fromISO(beginDate).plus({
              days: _i3
            }).toFormat('yyyy-MM-dd'));
          }
          if (this.dateTypeActive === 'month') {
            this.multipleChart.xAxis.categories.push(DateTime.fromISO(beginDate).plus({
              months: _i3
            }).toFormat('yyyy-MM'));
          }
          if (this.dateTypeActive === 'year') {
            this.multipleChart.xAxis.categories.push(DateTime.fromISO(beginDate).plus({
              years: _i3
            }).toFormat('yyyy'));
          }
        }
        this.multipleChart.series.forEach(function (x) {
          for (var _i4 = 0; _i4 < diff; _i4++) {
            x.data.push(null);
          }
        });

        // 下載 excel 用
        this.downloadArrayForExcel.forEach(function (x) {
          for (var _i5 = 0; _i5 < diff; _i5++) {
            x.data.push(null);
          }
        });
      }
    },
    getMultipleHourData: function getMultipleHourData() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _hourData$data;
        var data, hourData, _hourData$data2;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = [];
                _this4.multipleDataArr.forEach(function (x) {
                  var obj = {
                    fId: _this4.factoryInfo.find(function (y) {
                      return y.factory === x.factory;
                    }).factoryId,
                    siteName: x.factory,
                    todayDate: _this4.beginDate
                  };
                  data.push(obj);
                });
                _context.next = 4;
                return getMultipleHourDataApi(data);
              case 4:
                hourData = _context.sent;
                if (hourData !== null && hourData !== void 0 && (_hourData$data = hourData.data) !== null && _hourData$data !== void 0 && _hourData$data.success) {
                  _this4.multipleChartDataArr = hourData.data.data;
                  _this4.buildChart();
                } else {
                  _this4.$swal(hourData === null || hourData === void 0 ? void 0 : (_hourData$data2 = hourData.data) === null || _hourData$data2 === void 0 ? void 0 : _hourData$data2.msg);
                }
              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getMultipleDayData: function getMultipleDayData() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _dayData$data;
        var data, dayData, _dayData$data2;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                data = [];
                _this5.multipleDataArr.forEach(function (x) {
                  var obj = {
                    fId: _this5.factoryInfo.find(function (y) {
                      return y.factory === x.factory;
                    }).factoryId,
                    siteName: x.factory,
                    beginDate: _this5.beginDate,
                    endDate: _this5.endDate
                  };
                  data.push(obj);
                });
                _context2.next = 4;
                return getMultipleDayDataApi(data);
              case 4:
                dayData = _context2.sent;
                if (dayData !== null && dayData !== void 0 && (_dayData$data = dayData.data) !== null && _dayData$data !== void 0 && _dayData$data.success) {
                  _this5.multipleChartDataArr = dayData.data.data;
                  _this5.buildChart();
                } else {
                  _this5.$swal(dayData === null || dayData === void 0 ? void 0 : (_dayData$data2 = dayData.data) === null || _dayData$data2 === void 0 ? void 0 : _dayData$data2.msg);
                }
              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getMultipleMonthData: function getMultipleMonthData() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _monthData$data;
        var data, monthData, _monthData$data2;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                data = [];
                _this6.multipleDataArr.forEach(function (x) {
                  var obj = {
                    fId: _this6.factoryInfo.find(function (y) {
                      return y.factory === x.factory;
                    }).factoryId,
                    siteName: x.factory,
                    beginDate: _this6.beginDate,
                    endDate: _this6.endDate
                  };
                  data.push(obj);
                });
                _context3.next = 4;
                return getMultipleMonthDataApi(data);
              case 4:
                monthData = _context3.sent;
                if (monthData !== null && monthData !== void 0 && (_monthData$data = monthData.data) !== null && _monthData$data !== void 0 && _monthData$data.success) {
                  _this6.multipleChartDataArr = monthData.data.data;
                  _this6.buildChart();
                } else {
                  _this6.$swal(monthData === null || monthData === void 0 ? void 0 : (_monthData$data2 = monthData.data) === null || _monthData$data2 === void 0 ? void 0 : _monthData$data2.msg);
                }
              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    getMultipleYearData: function getMultipleYearData() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _yearData$data;
        var data, yearData, _yearData$data2;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                data = [];
                _this7.multipleDataArr.forEach(function (x) {
                  var obj = {
                    fId: _this7.factoryInfo.find(function (y) {
                      return y.factory === x.factory;
                    }).factoryId,
                    siteName: x.factory,
                    beginDate: _this7.beginDate,
                    endDate: _this7.endDate
                  };
                  data.push(obj);
                });
                _context4.next = 4;
                return getMultipleYearDataApi(data);
              case 4:
                yearData = _context4.sent;
                if (yearData !== null && yearData !== void 0 && (_yearData$data = yearData.data) !== null && _yearData$data !== void 0 && _yearData$data.success) {
                  _this7.multipleChartDataArr = yearData.data.data;
                  _this7.buildChart();
                } else {
                  _this7.$swal(yearData === null || yearData === void 0 ? void 0 : (_yearData$data2 = yearData.data) === null || _yearData$data2 === void 0 ? void 0 : _yearData$data2.msg);
                }
              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    downloadAnalysis: function downloadAnalysis() {
      var _this8 = this;
      var downloadArr = [];
      var fields = ['name'];
      fields = fields.concat(this.multipleChart.xAxis.categories);
      this.multipleChart.series.forEach(function (x) {
        downloadArr.push({
          name: x.name
        });
      });
      this.multipleChart.xAxis.categories.forEach(function (x, xindex) {
        downloadArr.forEach(function (y, yindex) {
          y["".concat(x)] = _this8.downloadArrayForExcel[yindex].data[xindex];
        });
      });
      downloadCsv(downloadArr, fields);
    }
  }),
  watch: {
    contextDataClass: function contextDataClass(oldValue, newValue) {
      if (oldValue !== newValue && this.multipleChartDataArr.length !== 0) {
        this.buildChart();
      }
    }
  },
  mounted: function mounted() {
    var _this9 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (_this9.factoryInfo.length) {
                _context5.next = 3;
                break;
              }
              _context5.next = 3;
              return _this9.asyncInfo();
            case 3:
              _this9.buildOptionArr();
            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  }
};